import { useQuery } from '@tanstack/react-query';

import { IProductsParams } from '@app/models/interfaces';
import Api from '@app/services/api';

export const useGetWarehouseProductsQuery = ({
  category_id,
  tag_id,
  only_positive_stock,
  brand_id,
  warehouse_uid,
  q,
  ...params
}: IProductsParams) => {
  return useQuery({
    queryKey: ['getWareHouseProducts', category_id, tag_id, brand_id, q, warehouse_uid],
    queryFn: () =>
      Api.products.getProducts({ category_id, tag_id, brand_id, warehouse_uid, only_positive_stock, q, ...params }),
  });
};
